<template>
  <div class="content-padding">
    <!--    <div v-if="popup.offline" class="offline-container">-->
    <!--      <img-->
    <!--        src="./components/weather-station/images/weather-station.png"-->
    <!--        alt=""-->
    <!--        style="height: 140px;display: block;width: 100%;object-fit: contain"-->
    <!--      >-->
    <!--      <div class="title">-->
    <!--        <van-icon name="warning-o" />设备已离线-->
    <!--      </div>-->
    <!--      <h3>请检查：</h3>-->
    <!--      <p>1.设备是否有电</p>-->
    <!--      <p>2.设备连接的路由器是否工作正常，网络通畅。</p>-->
    <!--      <h3>仍未解决：</h3>-->
    <!--      <p>请拨打技术支持电话13378118902</p>-->
    <!--    </div>-->
    <!--    <template v-else-if="sensorData.length">-->
    <template>
      <div class="score-container shadow-card">
        <wh-field-select-popup
          v-model="deviceData"
          :columns="deviceOptions"
          label="选择设备"
          value-key="id"
          class="device-select"
          @change="getDeviceData"
        />
        <div :style="{color:scoreColor}" class="circle-percent">
          <svg width="180" height="180" viewBox="0 0 180 180" class="percent-svg">
            <circle
              fill="transparent"
              stroke="#D8D8D8"
              stroke-width="10"
              stroke-dasharray="2 4"
              cx="90"
              cy="90"
              r="80"
            />
            <circle
              :stroke-dasharray="percentLength"
              fill="transparent"
              stroke="currentColor"
              stroke-width="10"
              stroke-linecap="round"
              cx="90"
              cy="90"
              r="80"
            />
            <circle
              fill="transparent"
              stroke-width="1"
              stroke="#D8D8D8"
              cx="90"
              cy="90"
              r="65"
            />
          </svg>
          <div class="text-content">
            <div class="name">
              -健康分-
            </div>
            <div class="score">
              <count-to :start-val="0" :end-val="score" :duration="3000" />
            </div>
            <div class="status">
              {{ scoreDesc }}
            </div>
          </div>
        </div>
      </div>
      <sensor-list :sensor-data="sensorData" :device-data="deviceData" />
      <weather-station :sensor-data="sensorData" />
    </template>
  </div>
</template>

<script>
import api from '@/api'
import WhFieldSelectPopup from '@/components/wh-field-select-popup/wh-field-select-popup'
import CountTo from 'vue-count-to'
import WeatherStation from './components/weather-station'
import SensorList from './components/sensor-list'

export default {
  name: 'Index',
  components: { SensorList, WhFieldSelectPopup, CountTo, WeatherStation },
  filters: {
    statusText(val) {
      return val ? '异常' : '适宜'
    }
  },
  data() {
    return {
      color: ['#FF8624', '#FF3B3B'],
      popup: {
        offline: false
      },
      deviceData: undefined,
      score: 0,
      scoreColor: undefined,
      scoreDesc: '',
      percentLength: '0',
      sensorData: [],
      deviceOptions: []
    }
  },
  created() {
    this.getIotDevice()
  },
  methods: {
    getIotDevice() {
      if (this.$store.getters.userData.secretKey) {
        api.getIotDevice().then(({ data }) => {
          this.deviceOptions = data.list.map(i => {
            return { text: i.nickname, value: i }
          })
          if (this.deviceOptions.length) {
            this.deviceData = this.deviceOptions[0].value
            this.getDeviceData()
          }
        })
      } else {
        this.$toast('暂无传感器相关数据!')
      }
    },
    getDeviceData() {
      if (!this.deviceData.id) return
      if (this.deviceData.deviceStatus === 'OFFLINE') {
        this.popup.offline = true
      }
      api.getDeviceDataNoGroup({
        productKey: this.deviceData.productKey,
        deviceName: this.deviceData.deviceName
      }).then(({ data, msg }) => {
        this.sensorData = setStatus(data.iotData)
        // 圆半径
        const c = 80 * 2 * Math.PI
        const score = parseInt(data.iotScore)
        this.score = score
        this.scoreDesc = data.desc
        this.percentLength = ((score / 100) * c).toFixed(0) + ' ' + c.toFixed(0)
        if (score < 60) {
          this.scoreColor = this.color[1]
        } else if (score < 80) {
          this.scoreColor = this.color[0]
        }
      })
      function setStatus(list) {
        list.forEach(i => {
          i.value = parseFloat(i.value)
          i.min = parseFloat(i.min)
          i.max = parseFloat(i.max)
          let status
          if (i.max === 0 && i.min === 0) return
          if (i.value < i.min) {
            status = 0
          } else if (i.value > i.max) {
            status = 1
          }
          i.status = status
        })
        return list
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content-padding {
  padding: 20px;
  background: #FBFBFB;
}
.shadow-card {
  background-color: #FFFFFF;
  box-shadow: 0 4px 12px 1px rgba(205, 205, 205, 0.2);
  border-radius: 12px;
  overflow: hidden;
}
.score-container {
  padding: 20px 20px 55px;
  .device-select {
    padding: 0;
    &::after {
      display: none;
    }
    ::v-deep {
      .van-field__label {
        font-size: 14px;
        font-weight: 500;
        color: #3D3D3D;
      }
    }
  }
  .title {
    font-size: 14px;
    color: #323332;
    .status-tag {
      display: inline-block;
      min-width: 42px;
      height: 16px;
      padding: 0 15px;
      border-radius: 11px;
      margin-left: 25px;
      font-size: 12px;
      color: #fff;
      line-height: 16px;
      text-align: center;
      background: #0188FE;
      &.warning {
        background: #FEA501;
      }
    }
  }
}
.circle-percent {
  position: relative;
  background: radial-gradient(circle at 15px 30px, currentColor 2px, transparent 3px),
              radial-gradient(circle at 40px 140px, currentColor 5px, transparent 6px),
              radial-gradient(circle at 250px 30px, currentColor 4px, transparent 5px),
              radial-gradient(circle at 225px 170px, currentColor 3px, transparent 4px),
              radial-gradient(circle at 200px 70px, currentColor 1px, transparent 2px);
  color: @primary-color;
  .text-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-weight: 500;
    .name {
      font-size: 12px;
      font-weight: 500;
      color: #767676;
    }
    .score {
      white-space: nowrap;
      font-size: 48px;
      .unit {
        font-size: 18px;
        color: #3D3D3D;
      }
    }
    .status {
      font-size: 14px;
    }
  }
}
.percent-svg {
  display: block;
  margin: 0 auto;
  circle {
    transform: rotate(-90deg);
    transform-origin: center;
    transition: all .5s;
  }
}
.offline-container {
  height: 100%;
  padding: 60px 0;
  color: #333;
  .title {
    margin: 20px 0;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    .van-icon {
      margin-right: 8px;
      color: red;
    }
  }
  h3 {
    font-size: 14px;
  }
  p {
    font-size: 14px;
    margin: 0;
    line-height: normal;
  }
}
</style>
